import { TaskType, TrackingTaskType } from '@griply/types';

export const taskTypeToTrackingTaskType: Record<TaskType, TrackingTaskType> = {
  [TaskType.Task]: TrackingTaskType.Todo,
  [TaskType.Habit]: TrackingTaskType.Habit,
  [TaskType.Repeating]: TrackingTaskType.Repeating,
};
